import { removeCookie } from 'Utils/BrowserCookies';
import { sendHandleSessionExpiredEvent } from 'Utils/events/flutterWebView';
import { ACCESS_TOKEN_STORAGE_KEY, KUESKI_SESSION_STORAGE_KEY } from '../consts/session';

export const removeSessionCredentials = () => {
  localStorage.removeItem(KUESKI_SESSION_STORAGE_KEY);
  localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
};

export const cleanSession = () => {
  localStorage.removeItem('email');
  removeSessionCredentials();
  localStorage.removeItem('is_known');
  localStorage.removeItem('gtmEvent');
  localStorage.removeItem('SHOW_IN_STORE_ALERT');
  removeCookie('multi_product');
  sendHandleSessionExpiredEvent();
};

export const getSessionToken = () => localStorage.getItem(KUESKI_SESSION_STORAGE_KEY) ?? null;
